<template>
    <b-container fluid>
        <b-row class="justify-content-md-center">
            <b-col md="7" sm="12" class="mt-2">
                <p style="font-size: 17px;color:#2284ab;">Preferred Job Location</p>
                <p></p>
                <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;">
                        <b-table show-empty head-variant="dark"
                                    stacked="md"
                                    bordered
                                    striped
                                    :items="docTbl"
                                    :fields="fields"
                                    style="font-size:12px"   
                        >

                            <template slot="Mapping" slot-scope="data">
                                <b-form-checkbox plain @click.native.stop v-model="data.item.Mapping">
                                </b-form-checkbox>
                            </template>
                        </b-table>
                </div>
                <b-row class="mt-2 justify-content-md-center" v-if="!LockProfile">
                    <b-col md="6" sm="12" style="text-align:center">
                    <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
                    <b-alert :show = "showDismissibleAlert" dismissible 
                        @dismissed="showDismissibleAlert=false"
                        
                        :variant="variant">
                        {{alertText}}
                    </b-alert>
                    </b-col>
                    <b-col  md="6" sm="12" style="text-align:right">
                    <b-button @click="onSubmit" variant="primary">Submit</b-button>
                    <!-- <b-button @click="onReset" variant="danger">Reset</b-button> -->
                    <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import * as _ from "lodash";

export default {
  components: { Spinner },
  data() {
    return {
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      saved: false,
      docObj: {},
      docTbl: [],
      fields: [
        { key: "BoardName", label: "Board Name" },
        { key: "Mapping", label: "Mapping" }
      ]
    };
  },
  computed: {
    LockProfile() {
      let userinfo = this.$store.getters.getUserData;
      if(userinfo)
      {
        return userinfo.LockProfile
      } else{
        return false;
      }
    }
  },
  methods: {
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    onReset() {},
    onSubmit(evt) {
      this.showDismissibleAlert = false;
      this.isLoading = true;
      evt.preventDefault();
      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      console.log(this.docTbl);
      
      //alert(JSON.stringify(this.docTbl));

      if (this.docTbl.length > 0) {
        let promise = apis.saveBoardMapping(this.docTbl);

        promise
          .then(response => {
            //console.log(response);
            if (response.status == 200) {
              this.alertText = "Data Saved Successfully";
              this.saved = true;
              this.variant = "success";
              this.showDismissibleAlert = true;
            } else {
              this.alertText = response.body;

              this.variant = "warning";
              this.showDismissibleAlert = true;
            }
            this.isLoading = false;
          })
          .catch(err => {
            this.alertText = err.body;
            this.showDismissibleAlert = true;
            this.variant = "danger";
            this.isLoading = false;
          });
      }
    },
    loadMapping() {
      this.showDismissibleAlert = false;
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      //   var filename =   this.Photo.name;
      let promise = apis.readBoardMapping(userid);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.docTbl = response.body;

            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    }
  },
  mounted() {
    this.loadMapping();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/RegistrationDetails/BoardChoices.vue